import { FC } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import { editFormDataAF, EditFormMode, IStationRouteDto } from "@ryde/shared";

import { StationRouteRebuildRouteDropdown } from "../../../drawers/components/station-route/station-route-rebuild-route-dropdown";
import { HeaderRightButtonsStyled } from "../../../header";
import { LayoutRightHistoryButton } from "../../../right";
import { StationRouteMeasuredTimesButton } from "./station-route-measured-times-button";

export const StationRouteHeaderButtons: FC = () => {
  const { entity, mode } = useCrudEditContext<IStationRouteDto>();
  const stationRouteDto = useRecoilValue<Partial<IStationRouteDto> | undefined>(
    editFormDataAF([entity, mode || EditFormMode.CrudRoute]),
  );

  return (
    <HeaderRightButtonsStyled className="StationRouteDrawer-HeaderButtons">
      <StationRouteMeasuredTimesButton stationRouteDto={stationRouteDto} />
      <StationRouteRebuildRouteDropdown stationRouteDto={stationRouteDto} />
      <LayoutRightHistoryButton entity={entity} dtoId={stationRouteDto?.id} />
    </HeaderRightButtonsStyled>
  );
};
